import React from "react";
import { Loading } from "../panels";
import Google from "./Google";

interface IProps {
  className?: string
  googleConnectAbsolute: string
  googleUserDetails?: server.dto.GoogleIdentityUserDetails
  allowDisconnect: boolean
  settingsUrl?: string
}

const ExternalIdentities = (props: IProps) => {
  const [googleUserDetails, setGoogleUserDetails] = React.useState<server.dto.GoogleIdentityUserDetails>(props.googleUserDetails);
  const [isFetching, setIsFetching] = React.useState<boolean>(false);
  const [fetchingError, setFetchingError] = React.useState<boolean>(false);

  React.useEffect(() => {
    setIsFetching(true);
    const googleDetails = window.CoreApi.Google.MyDetails();

    Promise.all([googleDetails])
      .then(([googleResult]) => {
        setGoogleUserDetails(googleResult.data);
      })
      .catch(_ => {
        setFetchingError(true);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, []);

  if (isFetching) {
    return <div>
      <Loading />
    </div>;
  }

  if (fetchingError) {
    return <div>
      There was an error fetching the connected accounts data
    </div>;
  }

  return (<>
    <div>
      <Google
        userDetails={googleUserDetails}
        canDisconnect={props.allowDisconnect}
        connectUrl={props.googleConnectAbsolute}
        settingsUrl={props.settingsUrl} />
    </div>

    {(((!googleUserDetails)) && props.allowDisconnect) && <div className="s1_gray margin-top" style={{ textAlign: "center" }}>
      {RESX.PersonalSettings.ConnectYourAccount}
    </div>}
  </>);
};

export default ExternalIdentities;